import { createContext } from 'react';
import { AuthInfo } from '@utils/api/user';

export type UserAuthContextValue = {
  authInfo: AuthInfo | null
}

export const UserAuthContext = createContext<UserAuthContextValue>({
  authInfo: null,
});
